import Api from '../Api';

import { url } from './config';
import { DocumentCounter } from './model';

class ExtendedApi extends Api<DocumentCounter> {}

const api = new ExtendedApi(url);

export default api;
